var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"total_static"},[(_vm.$store.getters.tagsView)?_c('img',{staticClass:"total_img",attrs:{"src":_vm.src,"alt":""}}):_vm._e(),_c('div',{},[_vm._v(_vm._s(_vm.str)+"："+_vm._s(_vm.total >=0 ? _vm.total:0)+_vm._s(_vm.unit))])])}
var staticRenderFns = []

export { render, staticRenderFns }